export default "__VITE_ASSET__f8511b71__"